import { inject, Injectable } from '@angular/core';
import { DocumentTypesClient } from './api/document-types-client.service';
import { Observable, tap } from 'rxjs';
import { DocumentTypeDto } from './api/models/document-type-dto.model';
import { LineOfBusinessEnum } from './api/enums/line-of-business-enum.enum';
import { DocumentTypeRequirementTextDto } from './api/models/document-type-requirement-text-dto.model';

// 2 endpoints
@Injectable({ providedIn: 'root' })
export class DocumentTypesClientWrapper {
    private readonly documentTypesClient: DocumentTypesClient = inject(DocumentTypesClient);
    // ** DocumentTypesController.SearchDocumentTypesAsync
    searchDocumentTypes(
        lineOfBusiness: LineOfBusinessEnum,
        name: string,
        facilityId?: number,
        associationId?: number,
        documentTypeCategoryId?: number
    ): Observable<DocumentTypeDto[]> {
        return this.documentTypesClient.searchDocumentTypes({
            lineOfBusiness,
            name,
            facilityId,
            associationId,
            documentTypeCategoryId,
            excludeDisabled: null
        });
    }

    // ** DocumentTypesController.GetDocumentTypeRequirementTextByIdAsync
    getDocumentTypeTextRequirements(
        documentTypeId: number,
        facilityId: number,
        associationId?: number,
        getInternalAndExternalDescriptions?: boolean
    ): Observable<DocumentTypeRequirementTextDto[]> {
        return this.documentTypesClient
            .getDocumentTypeRequirementTextById(
                documentTypeId,
                facilityId,
                associationId,
                getInternalAndExternalDescriptions
            )
            .pipe(
                tap((requirements: DocumentTypeRequirementTextDto[]) => {
                    requirements = requirements.sort((a, b) => {
                        let weightA = 3;
                        let weightB = 3;
                        if (a.association && a.association.id && (!a.facility || !a.facility.id)) {
                            weightA = 0;
                        } else if (a.association && a.association.id && a.facility && a.facility.id) {
                            weightA = 1;
                        } else if ((!a.association || !a.association.id) && a.facility && a.facility.id) {
                            weightA = 2;
                        }

                        if (b.association && b.association.id && (!b.facility || !b.facility.id)) {
                            weightB = 0;
                        } else if (b.association && b.association.id && b.facility && b.facility.id) {
                            weightB = 1;
                        } else if ((!b.association || !b.association.id) && b.facility && b.facility.id) {
                            weightB = 2;
                        }

                        return weightA - weightB;
                    });
                })
            );
    }
}
